// Links straight to one menu: app.rushmyfood.com/capeannpizza/catering opens
// the restaurant pinned (the short embed link) on the menu the last part names.
// src/index.js turns the path into /restaurant/<slug>?menu=<key>, and the
// restaurant page asks menuIndexForKey which of its menus that is.
//
// The admin's Embed Links page shows each menu's key, made by the backend
// (rushmyfood-backend src/utils/menuLinks.js). menuKey must stay the same in both.

export const CATERING_KEY = "catering";

export const squash = (s) => String(s || "").toLowerCase().replace(/[^a-z0-9]/g, "");

/** "Catering Menu" → "catering", "Lunch & Dinner" → "lunchdinner", "Menu" → "menu". */
export function menuKey(name) {
  return squash(String(name || "").replace(/\bmenus?\b/gi, " ")) || squash(name);
}

/**
 * Which of the page's menus (RestaurantDetail's menuTypes) a link key means, or
 * -1. "catering" is the Catering tab; a number is a menu id (the key a menu
 * gets when another took its name); otherwise the first menu whose name
 * matches, with or without the word "menu".
 */
export function menuIndexForKey(menuTypes, key) {
  const want = squash(key);
  if (!want || !Array.isArray(menuTypes)) return -1;
  if (want === CATERING_KEY) {
    const catering = menuTypes.findIndex((m) => m.isCatering);
    if (catering >= 0) return catering;
  }
  const regular = (find) => menuTypes.findIndex((m) => !m.isCatering && find(m));
  const byId = regular((m) => m._id != null && String(m._id) === want);
  if (byId >= 0) return byId;
  const byKey = regular((m) => menuKey(m.name) === want);
  if (byKey >= 0) return byKey;
  return regular((m) => squash(m.name) === want);
}
